/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientContent } from '../../models/client-content';
import { ClientContentApiRespModel } from '../../models/client-content-api-resp-model';

export interface ApiMasterClientContentAddPost$Params {
      body?: ClientContent
}

export function apiMasterClientContentAddPost(http: HttpClient, rootUrl: string, params?: ApiMasterClientContentAddPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientContentApiRespModel>> {
  const rb = new RequestBuilder(rootUrl, apiMasterClientContentAddPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClientContentApiRespModel>;
    })
  );
}

apiMasterClientContentAddPost.PATH = '/api/Master/ClientContent/Add';
